import { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  saveResourceDetails,
  fetchRoles,
  fetchDepartments,
  fetchBanks,
  fetchEmployeeTypes,
  fetchPaymentGroups,
  fetchCostCenters,
  fetchOfficeCodes,
  fetchPaymentBanks,
  fetchSalaryConfig,
  fetchLeaveName,
} from "../Api/ResourceMaster";
import { getCompanyCodesByOrganisation } from "../Api/CustomerMaster";
import { Container, Form, Button, Row, Col, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import { Collapse } from "react-bootstrap";
import { createPortal } from "react-dom";




import {
  FaUser,
  FaIdCard,
  FaUniversity,
  FaMoneyBillWave,
  FaUserTie,
  FaUsers,
  
} from "react-icons/fa";





const ResourceMaster = () => {
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [showSpouseName, setShowSpouseName] = useState(false);
  const { user } = useAuth();
  const [salaryConfig, setSalaryConfig] = useState({});
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const navigate = useNavigate();
  // dropdowns
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [banks, setBanks] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [paymentGroups, setPaymentGroups] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [officeCodes, setOfficeCodes] = useState([]);
  const [paymentBanks, setPaymentBanks] = useState([]);
const [showSalarySummary, setShowSalarySummary] = useState(false);
const [showStationDropdown, setShowStationDropdown] = useState(false);


  const [leavePolicies, setLeavePolicies] = useState([]);

  const [managers, setManagers] = useState([]);
const [stations, setStations] = useState([]);
const [selectedStation, setSelectedStation] = useState("");
const [selectedStations, setSelectedStations] = useState([]);
const stationInputRef = useRef(null);
const [stationDropdownStyle, setStationDropdownStyle] = useState({});

  // const [doj, setDoj] = useState("");
  // const [leaveType, setLeaveType] = useState("");

  const [companyCodes, setCompanyCodes] = useState([]);





  const defaultLocations = [
    { code: "Work from Home", description: "Work from Home" },
    { code: "Work from Office", description: "Work from Office" },
    { code: "Work from Client", description: "Work from Client" },
  ];

  const maritalStatusOptions = [
    { code: "Married", description: "Married" },
    { code: "Unmarried", description: "Unmarried" },
    { code: "Not declared", description: "Not declared" },
  ];

  const bloodGroupOptions = [
    { code: "A+", description: "A+" },
    { code: "A-", description: "A-" },
    { code: "B+", description: "B+" },
    { code: "B-", description: "B-" },
    { code: "O+", description: "O+" },
    { code: "O-", description: "O-" },
    { code: "AB+", description: "AB+" },
    { code: "AB-", description: "AB-" },
  ];

  const initialResourceData = {
    name: "",
    role: "",
    department: "",
    resourceId: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    employeeType: "",
    paymentGroup: "",
    emailId: "",
    companyCode: 0,
    paymentBank: "",
    costCenter: "",
    defaultLocation: "",
    officeCode: "",
    dob: "",
    fathersName: "",
    spouseName: "",
    maritalStatus: "",
    phoneNumber: "",
    panNumber: "",
    aadharNumber: "",
    bloodGroup: "",
    uanNumber: "",
    urlAadharCard: "",
    urlPanCard: "",
    emergencyContactName: "",
    emergencyContactRelation: "",
    emergencyContactPhoneNumber: "",
    address1: "", // Current Address Line 1
    address2: "", // Current Address Line 2
    address3: "", // Current Address Line 3
    address4: "", // Permanent Address Line 1
    address5: "", // Permanent Address Line 2
    address6: "", // Permanent Address Line 3
    createdBy: user?.userId,
    organisationId: user?.organisationId,
    doj: null,
      confirmationDate: "",      // ✅ NEW (auto calculated)
  gender: "",                // ✅ NEW
  personalEmailId: "", 
    statusReason: "",
    lineManager: "",
dotLineManager: "",
userName: "",
portalAccessAllowed: false, // ✅ NEW
stations: [], // array of recordGuid



    // leaveType: "",
 salary: {
  basic: 0,
  hra: 0,
  ma: 0,
  ta: 0,
  da: 0,
  ca: 0,
  mobile: 0,
  splAll: 0,

  pf: 0,            // Employee PF
  esic: 0,          // Employee ESIC
  pfCompany: 0,     // Employer PF
  esicCompany: 0,   // Employer ESIC

  gross: 0,
  ctc: 0,
  net: 0,
},

  };
  const statusOptions = [
    { code: "Prohibition", description: "Prohibition" },
    { code: "Confirmation", description: "Confirmation" },
    { code: "Resigned", description: "Resigned" },
    { code: "Left", description: "Left" },
    { code: "Terminated", description: "Terminated" }
  ];

  const [resourceData, setResourceData] = useState(initialResourceData);
  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const res = await axios.get(
          `${Base_URL}/SalaryProcess/ResourceMastersByOrgId/${user?.organisationId}`
        );
        setManagers(res.data || []);
      } catch (error) {
        toast.error("Failed to load manager list");
      }
    };

    if (user?.organisationId) {
      fetchManagers();
    }
  }, [user?.organisationId]);
useEffect(() => {
  const fetchStations = async () => {
    try {
      const res = await axios.get(
        `${Base_URL}/SalaryProcess/GetStationsforResource/${user?.organisationId}`
      );
      setStations(Array.isArray(res.data) ? res.data.filter(s => s.active) : []);
    } catch (err) {
      toast.error("Failed to load stations");
    }
  };

  fetchStations();
}, []);
const handleStationChange = (guid) => {
  setResourceData(prev => {
    const exists = prev.stations.includes(guid);
    return {
      ...prev,
      stations: exists
        ? prev.stations.filter(id => id !== guid)
        : [...prev.stations, guid],
    };
  });
};
useEffect(() => {
  if (resourceData.doj) {
    const dojDate = new Date(resourceData.doj);
    dojDate.setMonth(dojDate.getMonth() + 6);

    setResourceData(prev => ({
      ...prev,
      confirmationDate: dojDate.toISOString().split("T")[0],
    }));
  } else {
    setResourceData(prev => ({
      ...prev,
      confirmationDate: "",
    }));
  }
}, [resourceData.doj]);





  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          rolesData,
          deptsData,
          banksData,
          empTypesData,
          paymentGroupsData,
          costCentersData,
          officeCodesData,
          paymentBanksData,
          salaryconfig,
          companyCode,
          leavePoliciesResponse,
        ] = await Promise.all([
          fetchRoles(),
          fetchDepartments(),
          fetchBanks(user?.organisationId),
          fetchEmployeeTypes(),
          fetchPaymentGroups(),
          fetchCostCenters(),
          fetchOfficeCodes(user?.organisationId),
          fetchPaymentBanks(user?.organisationId),
          fetchSalaryConfig(user?.organisationId),
          getCompanyCodesByOrganisation(user?.organisationId),
          fetchLeaveName(user?.organisationId),
        ]);

        setRoles(rolesData);
        setDepartments(deptsData);
        setBanks(banksData);
        setEmployeeTypes(empTypesData);
        setPaymentGroups(paymentGroupsData);
        setCostCenters(costCentersData);
        setOfficeCodes(officeCodesData);
        setPaymentBanks(paymentBanksData);
        setSalaryConfig(salaryconfig);
        setCompanyCodes(companyCode);
        const leavePoliciesData =
          leavePoliciesResponse?.data || leavePoliciesResponse || [];
        setLeavePolicies(
          Array.isArray(leavePoliciesData) ? leavePoliciesData : []
        );
      } catch (error) {
        toast.error(`Error loading dropdown data: ${error.message}`);
      } finally {
        setFetchingData(false);
      }
    };

    if (user?.organisationId) {
      fetchAllData();
    }
  }, [user?.organisationId]);


  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "maritalStatus") {
  //     const isMarried = value === "Married";
  //     setShowSpouseName(isMarried);
  //     if (!isMarried) {
  //       setResourceData((prev) => ({
  //         ...prev,
  //         [name]: value,
  //         spouseName: "",
  //       }));
  //       return;
  //     }
  //   }

  //   setResourceData((prev) => ({
  //     ...prev,
  //     [name]: name === "companyCode" ? parseInt(value) || 0 : value,
  //   }));
  // };

const handleChange = (e) => { const { name, value, type, checked } = e.target; if (name === "maritalStatus") { const isMarried = value === "Married"; setShowSpouseName(isMarried); if (!isMarried) { setResourceData(prev => ({ ...prev, [name]: value, spouseName: "" })); return; } } setResourceData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : name === "companyCode" ? parseInt(value) || 0 : value })); };

// >>>>>>> main

 const handleSalaryChange = (e) => {
  const { name, value } = e.target;
  const numeric = value === "" ? 0 : parseFloat(value);

  setResourceData((prev) => {
    const s = {
      ...prev.salary,
      [name]: isNaN(numeric) ? 0 : numeric,
    };

    // 1️⃣ Gross = sum of all allowances
    const gross =
      (s.basic || 0) +
      (s.hra || 0) +
      (s.ma || 0) +
      (s.ta || 0) +
      (s.da || 0) +
      (s.ca || 0) +
      (s.mobile || 0) +
      (s.splAll || 0);

    // 2️⃣ CTC = Gross + Employer PF + Employer ESIC
    const ctc =
      gross +
      (s.pfCompany || 0) +
      (s.esicCompany || 0);

    // 3️⃣ Net Salary = Gross - Employee PF - Employee ESIC
    const net =
      gross -
      (s.pf || 0) -
      (s.esic || 0);

    return {
      ...prev,
      salary: {
        ...s,
        gross: Number(gross.toFixed(2)),
        ctc: Number(ctc.toFixed(2)),
        net: Number(net.toFixed(2)),
      },
    };
  });
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await saveResourceDetails(resourceData);
      toast.success(
        `Resource with Resource ID: ${response} added successfully`
      );
      navigate(`/updateResource/${resourceData.resourceId}`)
      setResourceData({
        ...initialResourceData,
        organisationId: user?.organisationId,
        createdBy: user?.userId,
      });
      setShowSpouseName(false);
    } catch (error) {
      toast.error(
        `Error: ${error.message || "Failed to save resource details"}`
      );
    } finally {
      setLoading(false);
    }
  };
  const handleSameAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);

    if (checked) {
      setResourceData((prev) => ({
        ...prev,
        address4: prev.address1,
        address5: prev.address2,
        address6: prev.address3,
      }));
    } else {
      setResourceData((prev) => ({
        ...prev,
        address4: "",
        address5: "",
        address6: "",
      }));
    }
  };
useEffect(() => {
  const close = () => setShowStationDropdown(false);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);

  return (
    <div className="container resource-master-fields">
      <h2 className="fields-title">Resource Master</h2>

      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion defaultActiveKey="0" alwaysOpen>
          {/* Employee Details */}
          <div className="_EmployeeDetailsContainer">
            {" "}
            <Accordion.Item eventKey="0">
              <Accordion.Header as="div" className="_DetailsHeader">
                <div className="details-header-content employee-header">
                  {/* LEFT: icon + title */}
                  <div className="employee-header-left">
                    <div className="details-icon-card">
                      <FaUser />
                    </div>
                    <span className="details-header-text">
                      Employee Details
                    </span>
                  </div>

                  {/* RIGHT: headings only */}
                  <div className="employee-header-summary">
                    <span>Name · DOB · Role ....</span>
                  </div>
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Row>
                  {/* COLUMN 1 */}
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Name <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={resourceData.name}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Date of Birth <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={resourceData.dob}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Role <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="role"
                        value={resourceData.role}
                        onChange={handleChange}
                        disabled={fetchingData}
                        required
                        className="resource-name"
                      >
                        <option value="">Select Role</option>
                        {roles.map((r) => (
                          <option key={r.code} value={r.code}>
                            {r.code} - {r.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Department <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="department"
                        value={resourceData.department}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                        className="resource-name"
                      >
                        <option value="">Select Department</option>
                        {departments.map((d) => (
                          <option key={d.code} value={d.code}>
                            {d.code} - {d.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Resource ID/Employee ID{" "}
                        <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="resourceId"
                        value={resourceData.resourceId}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Employee Type <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="employeeType"
                        value={resourceData.employeeType}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                        className="resource-name"
                      >
                        <option value="">Select Employee Type</option>
                        {employeeTypes.map((t) => (
                          <option key={t.code} value={t.code}>
                            {t.code} - {t.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Office Email ID <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="emailId"
                        value={resourceData.emailId}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Company Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="companyCode"
                        value={resourceData.companyCode}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      >
                        <option value="">Select Company</option>
                        {companyCodes.map((c) => (
                          <option key={c.companyCode} value={c.companyCode}>
                            {c.companyCode} - {c.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Date of Joining<span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="doj"
                        value={resourceData.doj}
                        onChange={handleChange}
                        required
                        className="resource-name"
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
  <Form.Group className="mb-3">
    <Form.Label>Confirmation Date</Form.Label>
    <Form.Control
      type="date"
      name="confirmationDate"
      value={resourceData.confirmationDate}
      readOnly
      disabled
      className="resource-name"
    />
  </Form.Group>
</Col>


                  {/* <Col md={4}> */}
                  {/* <Form.Group className="mb-3">
      <Form.Label>leave policy </Form.Label>
 <Form.Select
  name="leaveType"
  value={resourceData.leaveType}
  onChange={handleChange}
>  */}

                  {/* <option value="">Select Leave Type</option>
                   */}
                  {/* API-based options */}
                  {/* {Array.isArray(leavePolicies) && leavePolicies.length > 0 ? 
    leavePolicies.map((policy) => (
      <option key={policy.leavePolicyId} value={policy.leavePolicyId}>
        {policy.policyName}
      </option>
    ))
    : 
    <option value="" disabled>
      {fetchingData ? "Loading leave policies..." : "No leave policies available"}
    </option>
  } */}
                  {/* </Form.Select>
    </Form.Group>
  </Col> */}



     
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Code <span className="text-red">**</span></Form.Label>
                    <Form.Select
                      name="officeCode"
                      value={resourceData.officeCode}
                      onChange={handleChange}
                      required
                      disabled={fetchingData}
                    >
                      <option value="">Select Office Code</option>
                      {officeCodes.map((office) => (
                        <option key={office.code} value={office.code}>
                          {office.code} - {office.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
              <Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>
      Employee Status <span className="text-red">**</span>
    </Form.Label>
    <Form.Select
      name="statusReason"
      value={resourceData.statusReason}
      onChange={handleChange}
      required
    >
      {statusOptions.map(status => (
        <option key={status.code} value={status.code}>
          {status.description}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>
<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Check
      type="checkbox"
      name="portalAccessAllowed"
      label="Portal Access Allowed"
      checked={resourceData.portalAccessAllowed}
      onChange={handleChange}
    />
  </Form.Group>
</Col>
{resourceData.portalAccessAllowed && (
  <Col md={4}>
    <Form.Group className="mb-3">
      <Form.Label>
        User Name <span className="text-red">**</span>
      </Form.Label>
      <Form.Control
        type="text"
        name="userName"
        value={resourceData.userName}
        onChange={handleChange}
        placeholder="Enter portal username"
        required
      />
    </Form.Group>
  </Col>
)}


</Row>

<Row>
  <Col md={4}>
    <Form.Group className="mb-3 position-relative">
      <Form.Label>
        Stations <span className="text-red">*</span>
      </Form.Label>

      {/* Dropdown trigger (looks like normal select) */}
    <Form.Control
  ref={stationInputRef}
  readOnly
value={
  resourceData.stations.length
    ? stations
        .filter(st => resourceData.stations.includes(st.recordGuid))
        .map(st => st.stationName)
        .join(", ")
    : "Select Stations"
}

  placeholder="Select Stations"
  onClick={(e) => {
    e.stopPropagation();

    const rect = stationInputRef.current.getBoundingClientRect();

    setStationDropdownStyle({
      position: "fixed",
      top: rect.bottom + 4,
      left: rect.left,
      width: rect.width,
      zIndex: 10000,
    });

    setShowStationDropdown(!showStationDropdown);
  }}
  style={{ cursor: "pointer", backgroundColor: "#fff" }}
/>


      {/* Dropdown menu */}
  {showStationDropdown &&
  createPortal(
    <div
      style={{
        ...stationDropdownStyle,
        background: "#fff",
        border: "1px solid #ced4da",
        borderRadius: 6,
        maxHeight: 220,
        overflowY: "auto",
        boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {stations.map((station) => (
        <Form.Check
          key={station.recordGuid}
          type="checkbox"
          label={station.stationName}
          checked={resourceData.stations.includes(station.recordGuid)}
          onChange={() => handleStationChange(station.recordGuid)}
          className="station-dropdown-item"
         
        />
      ))}
    </div>,
    document.body
  )}


    </Form.Group>
  </Col>
</Row>





            </Accordion.Body>
          </Accordion.Item>
</div>
          {/* Personal Details */}
          <Accordion.Item eventKey="1">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaIdCard />
                  </div>
                  <span className="details-header-text">Personal Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Father's Name · Marital Status....</span>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Gender</Form.Label>
    <Form.Select
      name="gender"
      value={resourceData.gender}
      onChange={handleChange}
    >
      <option value="">Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Transgender">Transgender</option>
    </Form.Select>
  </Form.Group>
</Col>
<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Personal Email ID</Form.Label>
    <Form.Control
      type="email"
      name="personalEmailId"
      value={resourceData.personalEmailId}
      onChange={handleChange}
      placeholder="Enter personal email"
    />
  </Form.Group>
</Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Father's Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="fathersName"
                      value={resourceData.fathersName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Marital Status</Form.Label>
                    <Form.Select
                      name="maritalStatus"
                      value={resourceData.maritalStatus}
                      onChange={handleChange}
                    >
                      <option value="">Select Marital Status</option>
                      {maritalStatusOptions.map((status) => (
                        <option key={status.code} value={status.code}>
                          {status.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {showSpouseName && (
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Spouse Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="spouseName"
                        value={resourceData.spouseName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      value={resourceData.phoneNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>PAN Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="panNumber"
                      value={resourceData.panNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Aadhar Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="aadharNumber"
                      value={resourceData.aadharNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Blood Group</Form.Label>
                    <Form.Select
                      name="bloodGroup"
                      value={resourceData.bloodGroup}
                      onChange={handleChange}
                    >
                      <option value="">Select Blood Group</option>
                      {bloodGroupOptions.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>UAN Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="uanNumber"
                      value={resourceData.uanNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <hr />

              <h6 className="mb-3">Current Address</h6>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={resourceData.address1}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={resourceData.address2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="address3"
                      value={resourceData.address3}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Permanent address same as current address"
                  checked={sameAsCurrentAddress}
                  onChange={handleSameAddressChange}
                />
              </Form.Group>

              <h6 className="mb-3">Permanent Address</h6>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address4"
                      value={resourceData.address4}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address5"
                      value={resourceData.address5}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="address6"
                      value={resourceData.address6}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Bank Details */}
          <Accordion.Item eventKey="2">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUniversity />
                  </div>
                  <span className="details-header-text">Bank Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Bank Name · Account No. ....</span>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <Form.Select
                      name="bankName"
                      value={resourceData.bankName}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.code} value={bank.code}>
                          {bank.code} - {bank.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account No</Form.Label>
                    <Form.Control
                      type="text"
                      name="accountNo"
                      value={resourceData.accountNo}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>IFSC Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="ifscCode"
                      value={resourceData.ifscCode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Bank</Form.Label>
                    <Form.Select
                      name="paymentBank"
                      value={resourceData.paymentBank}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Payment Bank</option>
                      {paymentBanks.map((bank, index) => (
                        <option key={index} value={bank.code}>
                          {bank.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Group</Form.Label>
                    <Form.Select
                      name="paymentGroup"
                      value={resourceData.paymentGroup}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Payment Group</option>
                      {paymentGroups.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Other Details */}
          <Accordion.Item eventKey="3">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUsers />
                  </div>
                  <span className="details-header-text">Other Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Cost Center · Default Location ....</span>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Cost Center</Form.Label>
                    <Form.Select
                      name="costCenter"
                      value={resourceData.costCenter}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Cost Center</option>
                      {costCenters.map((center) => (
                        <option key={center.code} value={center.code}>
                          {center.code} - {center.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Default Location</Form.Label>
                    <Form.Select
                      name="defaultLocation"
                      value={resourceData.defaultLocation}
                      onChange={handleChange}
                    >
                      <option value="">Select Default Location</option>
                      {defaultLocations.map((location) => (
                        <option key={location.code} value={location.code}>
                          {location.code} - {location.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>URL Aadhar Card</Form.Label>
                    <Form.Control
                      type="text"
                      name="urlAadharCard"
                      value={resourceData.urlAadharCard}
                      onChange={handleChange}
                      placeholder="Enter URL for Aadhar Card"
                    />
                  </Form.Group>
                </Col> */}
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactName"
                      value={resourceData.emergencyContactName}
                      onChange={handleChange}
                      placeholder="Enter emergency contact name"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                {/* <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>URL PAN Card</Form.Label>
                    <Form.Control
                      type="text"
                      name="urlPanCard"
                      value={resourceData.urlPanCard}
                      onChange={handleChange}
                      placeholder="Enter URL for PAN Card"
                    />
                  </Form.Group>
                </Col> */}


                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Relation</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactRelation"
                      value={resourceData.emergencyContactRelation}
                      onChange={handleChange}
                      placeholder="Enter relation (e.g., Father, Mother)"
                    />
                  </Form.Group>
                </Col>
                   <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Phone</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactPhoneNumber"
                      value={resourceData.emergencyContactPhoneNumber}
                      onChange={handleChange}
                      placeholder="Enter emergency contact phone"
                    />
                  </Form.Group>
                </Col>
              </Row>

              
             
              
            </Accordion.Body>
          </Accordion.Item>

          {/* Salary Details */}
          <Accordion.Item eventKey="4">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaMoneyBillWave />
                  </div>
                  <span className="details-header-text">Salary Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Basic · HRA · MA ....</span>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
            <h4 className="salary-section-title">All Allowances</h4>
<Row>
  {salaryConfig?.basicPay && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>Basic</Form.Label>
        <Form.Control type="number" name="basic"
          value={resourceData.salary.basic}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.hra && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>HRA</Form.Label>
        <Form.Control type="number" name="hra"
          value={resourceData.salary.hra}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ma && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>MA</Form.Label>
        <Form.Control type="number" name="ma"
          value={resourceData.salary.ma}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ta && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>TA</Form.Label>
        <Form.Control type="number" name="ta"
          value={resourceData.salary.ta}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}
</Row>

<Row>
  {salaryConfig?.da && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>DA</Form.Label>
        <Form.Control type="number" name="da"
          value={resourceData.salary.da}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ca && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>CA</Form.Label>
        <Form.Control type="number" name="ca"
          value={resourceData.salary.ca}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.mobileInternetAllowence && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>Mobile Allowance</Form.Label>
        <Form.Control type="number" name="mobile"
          value={resourceData.salary.mobile}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  <Col xl={3} lg={3} md={6} sm={12}>
    <Form.Group className="mb-3">
      <Form.Label>Special Allowance</Form.Label>
      <Form.Control type="number" name="splAll"
        value={resourceData.salary.splAll}
        onChange={handleSalaryChange} />
    </Form.Group>
  </Col>
</Row>


            <hr />
<h4 className="salary-section-title">PF & ESIC</h4>
<Row>
  {salaryConfig?.pf && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>PF (Employer)</Form.Label>
        <Form.Control type="number" name="pfCompany"
          value={resourceData.salary.pfCompany}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.esi && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>ESIC (Employer)</Form.Label>
        <Form.Control type="number" name="esicCompany"
          value={resourceData.salary.esicCompany}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.pf && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>PF (Employee)</Form.Label>
        <Form.Control type="number" name="pf"
          value={resourceData.salary.pf}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.esi && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>ESIC (Employee)</Form.Label>
        <Form.Control type="number" name="esic"
          value={resourceData.salary.esic}
          onChange={handleSalaryChange} />
      </Form.Group>
    </Col>
  )}
</Row>


         <hr />
<h4 className="salary-section-title">Summary</h4>

<Row>
  <Col xl={3} lg={3} md={6} sm={12}>
    <Form.Group className="mb-3">
      <Form.Label>Gross</Form.Label>
      <Form.Control value={resourceData.salary.gross} readOnly />
    </Form.Group>
  </Col>
</Row>

<div
  style={{ cursor: "pointer", fontWeight: 600, color: "#0d6efd" }}
  onClick={() => setShowSalarySummary(p => !p)}
>
  {showSalarySummary ? "▼ Hide Salary Summary" : "▶ Show Salary Summary"}
</div>

{showSalarySummary && (
  <table className="table table-bordered text-center mt-3">
    <thead>
      <tr>
        <th></th>
        <th>Gross</th>
        <th>CTC</th>
        <th>Net</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Monthly</th>
        <td>{resourceData.salary.gross.toFixed(2)}</td>
        <td>{resourceData.salary.ctc.toFixed(2)}</td>
        <td>{resourceData.salary.net.toFixed(2)}</td>
      </tr>
      <tr>
        <th>Annual</th>
        <td>{(resourceData.salary.gross * 12).toFixed(2)}</td>
        <td>{(resourceData.salary.ctc * 12).toFixed(2)}</td>
        <td>{(resourceData.salary.net * 12).toFixed(2)}</td>
      </tr>
    </tbody>
  </table>
)}

            </Accordion.Body>
          </Accordion.Item>



          <Accordion.Item eventKey="5">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUserTie />
                  </div>
                  <span className="details-header-text">Manager Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Line Manager · Dot Line Manager ....</span>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Line Manager <span className="text-red"></span>
                    </Form.Label>
                    <Form.Select
                      name="lineManager"
                      value={resourceData.lineManager}
                      onChange={handleChange}
                    >
                      <option value="">Select Line Manager</option>
                      {managers.map((mgr) => (
                        <option key={mgr.resourceId} value={mgr.resourceId}>
                          {mgr.name} ({mgr.resourceId})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Dot Line Manager <span className="text-red"></span>
                    </Form.Label>
                    <Form.Select
                      name="dotLineManager"
                      value={resourceData.dotLineManager}
                      onChange={handleChange}
                    >
                      <option value="">Select Dot Line Manager</option>
                      {managers.map((mgr) => (
                        <option key={mgr.resourceId} value={mgr.resourceId}>
                          {mgr.name} ({mgr.resourceId})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>









        </Accordion>
        {/* Manager Details */}

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading || fetchingData}
          >
            {loading ? "Saving..." : "Save Resource"}
          </Button>
        </div>
      </Form>

      {(loading || fetchingData) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default ResourceMaster;
